
import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject} from 'rxjs';

import {distinctUntilChanged, debounceTime,  map } from 'rxjs/operators';
import {Component , ElementRef , OnInit , ViewChild , ViewChildren} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {OrganizationsService} from '../../../core/services/organizations.service';
import {DataSource} from '@angular/cdk/collections';
import {fuseAnimations} from '../../../core/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';



import {FuseUtils} from '../../../core/fuseUtils';
import {NgxSpinnerService} from 'ngx-spinner';
import {FusePerfectScrollbarDirective} from '../../../core/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { UserService } from '../../../core/services/users.service';
import { FuseConfigService } from '../../../core/services/config.service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import { EventService } from '../../../core/services/event.service';
@Component({
    selector: 'organization-page',
    templateUrl: './organization.component.html',
    styleUrls: ['./organization.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class OrganizationComponent implements OnInit {

  public filterData: any = {};

  organizations: FilesDataSource | null;
  displayedColumns = [ 'organizationType',  'name', 'logo' , 'website',   'city', 'canton', 'country', 'test' ];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChildren(FusePerfectScrollbarDirective) scroll;
  public subscription = new Subscription();
  userFilters;
  defUserFilters;
  isOrganizer = false;
  constructor (private http: HttpClient , private organizationService: OrganizationsService,
               private spinner: NgxSpinnerService , public snackBar: MatSnackBar, private router: Router,
               public userService: UserService, private fuseConfig: FuseConfigService,
               public eventService: EventService) {
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  ngOnInit () {
 this.subscription.add(this.fuseConfig.role.subscribe(res => {
      console.log('Res', res);
      if (res && res === 'organisationAdmin') {
        this.subscription.add(  this.fuseConfig.organizationId.subscribe(result => {
          console.log('Result', result);
          if (result) {
            this.router.navigate(['/pages/organization/detail'], {queryParams: {id: result}} );
          }
        }));
      }}));
    this.spinner.show();
    this.organizations = new FilesDataSource(this.organizationService , this.paginator , this.sort);
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged(),)
      .subscribe(() => {
        if (!this.organizations) {
          return;
        }
        this.organizations.filter = this.filter.nativeElement.value;
        this.paginator.firstPage();
      });
      this.getCountries();

    this.alertMsg();
    setTimeout(() => {
      this.spinner.hide();
    }, 500);
    this.paginator.page.subscribe((res) => {
      this.scroll.last.scrollToTop();
    });
    this.getUserFilters();
    this.fuseConfig.role.subscribe(res => {
      if (res && res === 'organisationAdmin') {
        this.isOrganizer = true;
      } else {
        this.isOrganizer = false;
      }
    });
  }

  alertMsg() {

  }

  getCountries() {
    this.organizationService.getCountry().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.countries = res;
      } else if (res.length === 1) {
        this.getCantons(res[0].id);
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getCantons(id){
    this.organizationService.getCity(id).subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.cantons = res;
      } else if (res.length === 1) {
        this.organizationService.setCities(res[0].id);
        this.fetchData();
      } else {
        delete this.filterData.cantons;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  chooseFilters(e) {
    // console.log(e);
    if (e.choose === 'all') {
      delete this.filterData.cantons;
      delete this.filterData.countries;
      this.organizationService.setCountryId('');
      this.fetchData();
      this.getCountries();
      this.fuseConfig.setActiveFilter(false);
    } else if (e.choose.hasOwnProperty('country')) {
      this.getCantons(e.choose.country);
      this.organizationService.setCountryId(e.choose.country);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    } else if (e.choose.hasOwnProperty('canton')) {
      this.organizationService.setCities(e.choose);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    this.setDataFromFilter(e);
  }

  getUserFilters() {
    this.userService.getFilter('organization').subscribe((res: any) => {
      if (res) {
        this.defUserFilters = res;
        this.userFilters = { organization: JSON.parse(res.config)};
        const config = JSON.parse(res.config);
        if (Object.keys(config).length) {
          this.fuseConfig.setActiveFilter(true);
        } else {
          this.fuseConfig.setActiveFilter(false);
        }
        const countryPromise = new Promise((resolve, reject) => {
          if (config.hasOwnProperty('country')) {
            this.organizationService.setCountryId(config.country);
            this.organizationService.getCity(+config.country).subscribe((resCanton: any) => {
              if (resCanton.length > 1) {
                this.filterData.cantons = resCanton;
              } else if (resCanton.length === 1) {
                this.organizationService.setCities(resCanton[0].id);
                this.fetchData();
              } else {
                delete this.filterData.cantons;
              }
              this.filterData = JSON.parse(JSON.stringify(this.filterData));
              resolve(true);
            });
          } else {
            resolve(true);
          }
        });

        const cantonsPromise = new Promise((resolve, reject) => {
          if (config.hasOwnProperty('cantons')) {
            config.cantons.forEach(el => {
              this.organizationService.setCities({canton: el, selected: true});
            });
            resolve(true);
          } else {
            resolve(true);
          }
        });
        Promise.all([countryPromise, cantonsPromise]).then(values => {
          console.log(values);
          this.fetchData();
        });

      } else {
        this.fuseConfig.setActiveFilter(false);
        this.userFilters = { organization: {}};
        this.defUserFilters = '';
      }
    });
  }

  setUserFilters(key, value) {
    this.userFilters.organization[key] = value;
    this.userService.setFilters('organization', this.userFilters.organization, this.defUserFilters ? this.defUserFilters.id : '')
      .subscribe((res: any) => {
        this.defUserFilters = res;
      });
  }

  setEmptyUserFilters() {
    this.userService.setFilters('organization', {}, this.defUserFilters ? this.defUserFilters.id : '')
      .subscribe((res: any) => {
        this.defUserFilters = res;
      });
  }

  setDataFromFilter(e) {
    if (e.choose === 'all') {
      this.userFilters.organization = {};
      this.setEmptyUserFilters();
    } else if (e.choose.hasOwnProperty('country')) {
      this.setUserFilters('country', e.choose.country);
    } else if (e.choose.hasOwnProperty('canton')) {
      const _cities = this.organizationService.getCities();
      this.setUserFilters('cantons', _cities);
    }
  }


  fetchData () {
    this.spinner.show();
    this.organizationService.getOrganizations().then(() => {
      setTimeout(() => {
        this.paginator.firstPage();
        this.spinner.hide();
      } , 500);
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}


export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private organizationService: OrganizationsService  ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.organizationService.organizations;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.organizationService.onOrganizationsChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.organizationService.organizations.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    // console.log(data);
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }

  sortData (data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';
      switch (this._sort.active) {
        // case 'postcode':
        //   [ propertyA , propertyB ] = [ a.postcode , b.postcode ];
        //   break;
        // case 'address':
        //   [ propertyA , propertyB ] = [ a.address , b.address ];
        //   break;
        case 'website':
          [ propertyA , propertyB ] = [ a.website , b.website ];
          break;
        case 'name':
          [ propertyA , propertyB ] = [ a.name , b.name ];
          break;
        case 'city':
          [ propertyA , propertyB ] = [ a.cityLocation , b.cityLocation ];
          break;
        case 'country':
          [ propertyA , propertyB ] = [ a.country.name , b.country.name ];
          break;
        case 'organizationType':
          [ propertyA , propertyB ] = [ a.organizationType.name , b.organizationType.name ];
          break;
        case 'canton':
          [ propertyA , propertyB ] = [ a.city.name , b.city.name ];
          break;

      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
